import React, { useState, useEffect, useRef } from "react";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import { useNavigate, useLocation } from "react-router-dom";
import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { toast } from "react-toastify";
import Loader from "../../../Loader";
import './InsurancePrint.scss';

const InsurancePrint = () => {
  const myRef = useRef();
  const navigateTo = useNavigate();
  const myLocation = useLocation();
  const insuranceId = myLocation?.state?.insuranceId;
  const [printData, setPrintData] = useState({});
  const [isLoad, setIsLoad] = useState(false);

  useEffect(() => {
    _axios.get(prefixUrl() + `/insurance/?request=insurancePrintData&insuranceId=${insuranceId}`)
      .then((response) => {
        if (response.data.status) {
          setPrintData(response?.data.data);
          setIsLoad(true);
        } else {
          toast.error(response?.data.message);
        }
      });
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      const printButton = document.getElementById("printButton");
      if (printButton) {
        printButton.click();
      }
    }, 100);

    return () => clearTimeout(timeout);
  }, [isLoad]);

  const totalAmount = printData?.installment_details?.reduce((sum, row) => sum + (row?.price || 0), 0);

  const formatBankNumber = (number) => {
    return number?.match(/.{1,4}/g)?.join("‎ - ") || "";
  };

  const phoneSVG = <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    fill="none"
    viewBox="0 0 12 12"
  >
    <path
      fill="#808487"
      d="M2.409.643a.98.98 0 0 1 .649.5l.446.802c.165.295.303.543.394.759.096.229.153.455.127.705s-.129.458-.27.663c-.133.192-.32.407-.541.662l-.657.754c-.118.135-.176.202-.182.287-.005.084.043.156.14.3a11.7 11.7 0 0 0 3.16 3.16c.144.097.216.145.3.14.085-.005.152-.064.287-.182l.755-.656c.254-.222.469-.409.661-.542.205-.141.414-.243.664-.27.25-.026.475.031.704.127.216.09.464.23.76.394l.8.446c.252.14.443.366.501.65.06.286-.028.574-.22.81-.7.858-1.82 1.405-2.997 1.168-.722-.146-1.435-.39-2.297-.884a11.9 11.9 0 0 1-4.28-4.278C.82 5.295.577 4.582.432 3.86.193 2.684.74 1.563 1.598.864c.237-.193.524-.28.81-.221"
    ></path>
  </svg>

  try {
    return !isLoad ? (
      <Loader />
    ) : (
      <div style={{ width: "100%", textAlign: "center", marginTop: "1rem" }}>
        <div>
          <ReactToPrint
            content={() => myRef.current}
            onAfterPrint={() => navigateTo(-1)}
          >
            <PrintContextConsumer>
              {({ handlePrint }) => (<button
                id={"printButton"}
                className={"btnCustom btnSubmit"}
                onClick={handlePrint}>
                چاپ
              </button>)}
            </PrintContextConsumer>
          </ReactToPrint>
        </div>

        <div style={{ maxWidth: "50vw", margin: "0 auto", paddingTop: "1rem" }}>
          <section className='insurance-print' ref={myRef}>
            {/*  اطلاعات بالای جدول */}
            <div className="insurance-info">
              <div className="info-row info-title">
                <span>لیست اقساط بیمه ایران - {printData?.header_name}</span>
              </div>
              <div className="info-row">
                <div className="info-cell">
                  <span>شماره بیمه نامه</span>
                  <span>{printData?.insurance_number}</span>
                </div>
                <div className="info-cell">
                  <span>نام بیمه گذار</span>
                  <span>{printData?.insurance_customer}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-cell">
                  <span>شماره کارت</span>
                  <span>{formatBankNumber(printData?.card_number)}</span>
                </div>
                <div className="info-cell">
                  <span>شماره حساب</span>
                  <span>{printData?.account_number}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-cell">
                  <span>شماره شبا</span>
                  <span>{formatBankNumber(printData?.shaba_number)}</span>
                </div>
                <div className="info-cell">
                  <span>{printData?.bank_name}</span>
                  <span>{printData?.account_name}</span>
                </div>
              </div>
            </div>
            {/* جدول */}
            <div className="insurance-table">
              <table>
                <thead>
                  <tr>
                    <th style={{ width: "10%" }} className="row-header">ردیف</th>
                    <th style={{ width: "20%" }} colSpan="3">تاریخ اقساط</th>
                    <th style={{ width: "20%" }} colSpan="2">مبلغ قسط</th>
                    <th style={{ width: "20%" }} >تاریخ</th>
                    <th style={{ width: "20%" }} >امضا</th>
                  </tr>
                </thead>
                <tbody>
                  {printData?.installment_details.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{String(row?.day).padStart(2, "0")}</td>
                      <td>{String(row?.month).padStart(2, "0")}</td>
                      <td>{row?.year}</td>
                      <td className="amount-number">{(row?.price).toLocaleString()}</td>
                      <td className="amount-currency">ریال</td>
                      <td></td>
                      <td></td>
                    </tr>
                  ))}
                  <tr className="total-row">
                    <td colSpan="4">جمع کل</td>
                    <td className="amount-number">{totalAmount.toLocaleString()}</td>
                    <td className="amount-currency">ریال</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <div className="note-container">
                <p className="note">
                  در صورت تاخیر در پرداخت اقساط، این شرکت هیچگونه مسئولیتی در قبال خسارت احتمالی را ندارد.
                </p>
              </div>
            </div>

            <div className="contact-info">
              <div className="contact-header">
                <span>تلفن های تماس جهت واریزی اقساط</span>
              </div>
              <div className='contact-main'>
                <div className="contact-row">
                  <div className="phone-number">
                    <span>{printData?.telephone_1}</span>
                    {phoneSVG}
                  </div>
                  <div className="phone-number">
                    <span>{printData?.telephone_2}</span>
                    {phoneSVG}
                  </div>
                  <div className="phone-number">
                    <span>{printData?.telephone_3}</span>
                    {phoneSVG}
                  </div>
                  <div className="phone-number">
                    <span>{printData?.telephone_4}</span>
                    {phoneSVG}
                  </div>
                </div>
                <div className="contact-address">
                  <span>آدرس : {printData?.address}</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default React.memo(InsurancePrint);